export default {
    "title": "Panel de Administración Extranet",
    "description": "Resumen de clientes, usuarios e inicios de sesión producidos",
    "clients": "Clientes",
    "users": "Usuarios",
    "kpis": {
        "total": "Totales",
        "active": "Activos",
        "inactive": "Inactivos"
    },
    "lastClients": "Últimos clientes registrados",
    "lastUsers": "Últimos usuarios registrados",
    "chart": {
        "title": "Inicios de sesión en los últimos 12 meses",
        "series": {
            "logins": "Inicios de sesión"
        }
    },
    "lastLogins": "Últimos inicios de sesión"
}